import _ from 'lodash'

let gItemKeyUUID = 1;

export default {
  methods: {
    // Goes up the tree finding a component parent matching the same class name
    findComponentParent(comp, className) {
      if(comp == null)
        return null
      if(comp.$options.name == className)
        return comp

      return this.findComponentParent(comp.$parent, className)
    },

    // Build a query string from an object with keys/value params
    buildQueryParams(params) {
      var array = []

      for(var key in params) {
        array.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]))
      }

      return array.join("&")
    },

    // Detect if the page is running via the Synergy Desktop App
    isDesktopAppMode() {
      let userAgent = (navigator.userAgent || '').trim().toLowerCase()
      let desktopAppMatch = userAgent.match("synergydesktopapp")
      return (desktopAppMatch != null)
    },

    // Generate a version of a simple array adding an extra 'key' property that is unique to the array element
    // Used for creating Vue loops over simple arrays that do not use id properties
    generateKeyedList(list) {
      if(!list)
        return []

      return list.map(i => {
        let key = !i.key ? this.getUniqueListKey() : i.key
        return _.defaults(_.cloneDeep(i), { key: key })
      })
    },

    getUniqueListKey() {
      return `temp-id-` + gItemKeyUUID++
    },

    addSystemLog(message) {
      this.$store.commit("system/addSystemLog", message)
    },

    // Fin nearest parent to an element that has scrolling set
    findScrollParent(element, includeHidden = false) {
      var style = getComputedStyle(element)
      var excludeStaticParent = style.position === "absolute"
      var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/
  
      if(style.position === "fixed")
        return document.body
      for (var parent = element; (parent = parent.parentElement);) {
          style = getComputedStyle(parent)
          if(excludeStaticParent && style.position === "static")
            continue
          if(overflowRegex.test(style.overflow + style.overflowY + style.overflowX))
            return parent
      }
  
      return document.body
    }
  }
}